import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.js'
import './index.css'
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Login from "./auth/Login.js";
import Auth from "./auth/Auth.js";
import ProtectedRoute from "./util/ProtectedRoute.js";
import Home from "./components/Home.js";
import VendorList from "./components/routes/VendorList";
import TasksList from "./components/routes/TasksList";
import OutletList from "./components/routes/OutletList";
import SharedTask from "./components/routes/SharedTask";
import {Toaster} from "react-hot-toast";
import TaskPage from "./pages/TaskPage";
import ChanelPage from "./pages/ChanelPage";
import VendorPage from "./pages/VendorPage";
import SellerPage from "./pages/SellerPage";
import ChannelProgramsPage from "./pages/ChannelProgramsPage";
import BrandsPage from './pages/BrandsPage'
import WorkTypesPage from './pages/WorkTypesPage.jsx';

ReactDOM.createRoot(document.getElementById('root')).render(
    <BrowserRouter basename={'/'}>
        <Toaster
            containerStyle={{zIndex: 50000}}
            position="top-right"
            toastOptions={{
                // Default options for specific types
                success: {
                    style: {
                        border: '2px solid blue',
                        color: 'blue',
                    },
                },
                error: {
                    style: {
                        border: '2px solid red',
                        color: 'red',
                    },
                },
            }}
        />
        <Routes>
            <Route path='/auth' element={<Auth />}>
                <Route path='login' element={<Login />} />
            </Route>
            <Route path='/sharedTask/:taskToken' element={<Auth />}>
                <Route path='' element={<SharedTask />} />
            </Route>
            <Route path="/" element={<App />}>
                <Route path='' element={
                    <ProtectedRoute>
                        {/*<Home />*/}
                        <TasksList />
                    </ProtectedRoute>
                } />
                <Route path='/vendorList' element={
                    <ProtectedRoute>
                        <VendorList />
                    </ProtectedRoute>
                } />
                <Route path='/tasksList/:selectedRowId' element={
                    <ProtectedRoute>
                        <TasksList />
                    </ProtectedRoute>
                } />
                <Route path='/task/:taskId' element={
                    <ProtectedRoute>
                        <TaskPage />
                    </ProtectedRoute>
                } />
                <Route path='/vendor/:id' element={
                    <ProtectedRoute>
                        <VendorPage />
                    </ProtectedRoute>
                } />
                <Route path='/outletList' element={
                    <ProtectedRoute>
                        <OutletList />
                    </ProtectedRoute>
                } />

                <Route path='/chanelManager' element={
                    <ProtectedRoute>
                        <ChanelPage />
                    </ProtectedRoute>
                } />
                <Route path='/sellers' element={
                    <ProtectedRoute>
                        <SellerPage />
                    </ProtectedRoute>
                } />
                <Route path='/channelPrograms' element={
                    <ProtectedRoute>
                        <ChannelProgramsPage />
                    </ProtectedRoute>
                } />
                <Route path='/brands' element={
                    <ProtectedRoute>
                        <BrandsPage />
                    </ProtectedRoute>
                } />
                <Route path='/workTypes' element={
                    <ProtectedRoute>
                        <WorkTypesPage />
                    </ProtectedRoute>
                } />
            </Route>
        </Routes>
    </BrowserRouter>
)
